import { cn } from '../../../../lib/utils';
import { Separator } from '../../../../ui/separator';
import type { BaseFieldProps, DividerFieldSchema, HeadingFieldSchema } from '../../../types';

export function HeadingField({ field, className }: BaseFieldProps<HeadingFieldSchema, void>) {
  const Level = `h${field.level || 2}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

  const sizeClasses = {
    1: 'text-3xl font-bold',
    2: 'text-2xl font-semibold',
    3: 'text-xl font-medium',
    4: 'text-lg font-medium',
    5: 'text-base font-medium',
    6: 'text-sm font-medium',
  }[field.level || 2];

  return (
    <Level className={cn(sizeClasses, 'tracking-tight mt-6 mb-2', className)}>{field.label}</Level>
  );
}

export function DividerField({ field: _field }: BaseFieldProps<DividerFieldSchema, void>) {
  return <Separator className="my-6" />;
}
